import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/design-system/atoms/modal';
import { PopUp } from '@/components/design-system/molecules/pop-up';

interface SuccessModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  title,
  description,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <PopUp
        type="feedback"
        title={title}
        description={description}
        primaryButtonProps={{
          onClick: onClose,
          title: t('js.features.marketplace.subscription_success_modal.done_button'),
        }}
      />
    </Modal>
  );
};

export default SuccessModal;
